import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import { AboutFetchData } from "../../APIS/FetchAPIs";
import "./About.css";
import TestimonialSection from "../../Component/TestimonialsCMPT/TestimonialSection";
import AboutSection2Home from "../../Component/AboutCMPT/AboutSection2Home";
import ServiceSectionHome from "../../Component/ServiceCMPT/ServiceSectionHome";
import WhyChooseUsSection from "../../Component/WhyChooseUs/WhyChooseUsSection";

export default function About() {
  const { RendomTokenfetch } = useAuth();
  const [aboutData] = AboutFetchData(RendomTokenfetch);

  return (
    <>
      <Helmet>
        <title>{aboutData.meta_title}</title>
        <meta name="description" content={aboutData.meta_description} />
        <meta name="keywords" content={aboutData.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="About" mainpage="" />
      <section
        className="about-us-section about-us-section-style3 section-padding section_padding_buttom_zero"
        style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="row section-title">
            <h2>{aboutData?.title || ""}</h2>
          </div>

          <div className="row content">
            <div className="col col-md-7">
              <div className="box">
                <h3>{aboutData?.about_tagline || ""}</h3>
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: aboutData.about_description,
                  }}
                ></div>
              </div>
            </div>

            <div className="col col-md-5 about-company-slider-wrapper">
              <div className="about-company-slider">
                <div>
                  {aboutData.about_image !== "" ? (
                    <img
                      src={aboutData.about_image}
                      alt={aboutData.aboutimg_alt}
                      title={aboutData.aboutimg_title}
                      className="img img-responsive"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AboutSection2Home />

      {aboutData.vision ||
        (aboutData.mission && (
          <section
            className="AboutMission fix section-padding bg-cover pb-3"
            style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
          >
            <div className="container">
              <div className="aboutwrapper">
                <div className="row g-4">
                  <div className="col-xl-6 col-lg-6">
                    {aboutData.vision && (
                      <div className="content">
                        <div className="section-title mb-0">
                          <h2 className="">Our Vision</h2>
                        </div>
                        <p className="aboutVissionPera mt-3">
                          {aboutData?.vision || ""}
                        </p>
                      </div>
                    )}

                    {aboutData.mission && (
                      <div className="content">
                        <div className="section-title mb-0">
                          <h2 className="">Mission</h2>
                        </div>
                        <p className=" mt-3">{aboutData?.mission || ""}</p>
                      </div>
                    )}
                  </div>
                  {aboutData.missionimage && (
                    <div className="col-xl-6 col-lg-6">
                      <div className="MissionVissionimage">
                        {aboutData.missionimage !== "" ? (
                          <img src={aboutData.missionimage} alt="" />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        ))}

      {aboutData.our_experience && (
        <section
          className="propertie-section-3 fix section-padding bg-cover pt-0"
          style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
        >
          <div className="container">
            <div className="propertie-wrapper-3">
              <div className="row g-4">
                <div className="section-title mb-0">
                  <h2 className=" aboutSectiontitle">
                    Our Experience & Achievements
                  </h2>
                </div>
                {aboutData.experienceimage && (
                  <div className="col-xl-6 col-lg-6">
                    <div className="Achievementsimage">
                      {aboutData.experienceimage !== "" ? (
                        <img src={aboutData.experienceimage} alt="" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}

                <div className="col-xl-6 col-lg-6">
                  <div className="content">
                    <p className="">{aboutData?.our_experience || ""}</p>
                  </div>
                </div>

                {/* <div className="col-lg-8 col-sm-12 aboutFAQS">
                <div className="faq-content">
                  <h2 className="mt-3 mb-3 aboutSectiontitle">
                    What Sets Us Apart
                  </h2>
                  <div className="faq-accordion">
                    <div className="accordion" id="accordion">
                      {aboutData.title1 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq1"
                              aria-expanded="false"
                              aria-controls="faq1"
                            >
                              {aboutData?.title1 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq1"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline1 || ""}
                            </div>
                          </div>
                        </div>
                      )}

                      {aboutData.title2 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq2"
                              aria-expanded="true"
                              aria-controls="faq2"
                            >
                              {aboutData?.title2 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq2"
                            className="accordion-collapse show"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline2 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                      {aboutData.title3 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq4"
                              aria-expanded="false"
                              aria-controls="faq4"
                            >
                              {aboutData?.title3 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq4"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline3 || ""}
                            </div>
                          </div>
                        </div>
                      )}

                      {aboutData.title4 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq5"
                              aria-expanded="false"
                              aria-controls="faq5"
                            >
                              {aboutData?.title4 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq5"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline4 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                      {aboutData.title5 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq6"
                              aria-expanded="false"
                              aria-controls="faq6"
                            >
                              {aboutData?.title5 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq6"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline5 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div> */}

                {aboutData.our_promise && (
                  <div className="col-xl-12 col-lg-12 OurPromissDiv">
                    <div className="content">
                      <div className="section-title mb-0">
                        <h2>Our Promise</h2>
                      </div>
                      <p>{aboutData?.our_promise || ""}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      <WhyChooseUsSection />
      <ServiceSectionHome />
      <TestimonialSection />
    </>
  );
}
